import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface MissingLicenseProps {
  heading?: string
  body1?: string
  body2?: string
  moreInfo?: string
  quadriPlans?: string
  info?: string
  andCheck?: string
  subscriptions?: string
}

const MissingLicense = (props: MissingLicenseProps) => {
  return (
    <div
      className="d-flex h-100 flex-column justify-content-center align-items-center text-center text-muted"
      data-testid="missingLicensediv"
    >
      <div
        className="bg-gray_0 d-block rounded d-flex justify-content-center align-items-center mb-1"
        style={{ width: "192px", height: "192px" }}
      >
        <i className="icon-font i64 tc-icon-error-alt"></i>
      </div>
      <h1 className="mb-1">{props.heading}</h1>
      <p>{props.body1! + " " + props.info + props.body2}</p>
      <div className="mt-2">
        {props.moreInfo}{" "}
        <a href="https://quadri.trimble.com/buy" rel="noreferrer" target="_blank">
          {props.quadriPlans}
        </a>{" "}
        {props.andCheck}{" "}
        <a href="https://np.trimble.com/Manage/Products" rel="noreferrer" target="_blank">
          {props.subscriptions}
        </a>
      </div>
    </div>
  )
}

export default MissingLicense
